var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home2"},[_c('HeroHeader2'),_vm._v(" "),_c('div',{staticClass:"site-content"},[_c('CTA3'),_vm._v(" "),_c('intro'),_vm._v(" "),_c('Story'),_vm._v(" "),_c('Features2'),_vm._v(" "),_c('Images'),_vm._v(" "),_c('CTA2'),_vm._v(" "),_c('CTA3'),_vm._v(" "),_c('footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b3128764","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Home2.vue
// module id = null
// module chunks = 